module.exports = __webpack_public_path__ + "static/img/banner.c741432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LanguageTest/banner.png
// module id = Ukd9
// module chunks = 23